/**
 * Recently Viewed Products — localStorage tracking with client-side rendering.
 * Stores up to 8 product handles, renders up to 4 on product pages.
 */
window.ToyBox = window.ToyBox || {};

ToyBox.recentlyViewed = (function () {
  var STORAGE_KEY = 'toybox:recently-viewed';
  var MAX_STORED = 8;
  var MAX_DISPLAYED = 4;

  function formatMoney(cents) {
    if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
      return Shopify.formatMoney(cents);
    }
    var amount = (cents / 100).toFixed(2).replace('.', ',');
    return '\u20AC' + amount;
  }

  function getHandles() {
    try {
      var data = localStorage.getItem(STORAGE_KEY);
      return data ? JSON.parse(data) : [];
    } catch (e) {
      return [];
    }
  }

  function trackProduct(handle) {
    if (!handle) return;
    var handles = getHandles();
    handles = handles.filter(function (h) {
      return h !== handle;
    });
    handles.unshift(handle);
    if (handles.length > MAX_STORED) {
      handles = handles.slice(0, MAX_STORED);
    }
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(handles));
    } catch (e) {
      // localStorage full or unavailable
    }
  }

  function renderSection(containerId, excludeHandle) {
    var container = document.getElementById(containerId);
    if (!container) return;

    var handles = getHandles().filter(function (h) {
      return h !== excludeHandle;
    });

    if (handles.length === 0) {
      var section = container.closest('.recently-viewed');
      if (section) section.style.display = 'none';
      return;
    }

    handles = handles.slice(0, MAX_DISPLAYED);
    var fetches = handles.map(function (handle) {
      return fetch('/products/' + handle + '.js')
        .then(function (res) {
          return res.ok ? res.json() : null;
        })
        .catch(function () {
          return null;
        });
    });

    Promise.all(fetches).then(function (products) {
      var validProducts = products.filter(function (p) {
        return p !== null;
      });

      if (validProducts.length === 0) {
        var section = container.closest('.recently-viewed');
        if (section) section.style.display = 'none';
        return;
      }

      var template = document.getElementById('recently-viewed-card-template');
      container.innerHTML = '';

      validProducts.forEach(function (product) {
        var card = template.content.firstElementChild.cloneNode(true);
        var productUrl = '/products/' + product.handle;

        var link = card.querySelector('[data-slot="link"]');
        if (link) link.href = productUrl;

        var titleEl = card.querySelector('[data-slot="title-link"]');
        if (titleEl) titleEl.textContent = product.title;

        if (product.featured_image) {
          var imgEl = card.querySelector('[data-slot="image"]');
          if (imgEl) {
            imgEl.src = product.featured_image.replace(/(\.[^.]+)$/, '_400x$1');
            imgEl.alt = product.title;
          }
        } else {
          var mediaEl = card.querySelector('.rv-card__media');
          if (mediaEl) mediaEl.innerHTML = '';
        }

        var priceEl = card.querySelector('[data-slot="price"]');
        if (priceEl && product.price) {
          priceEl.textContent = formatMoney(product.price);
        }

        container.appendChild(card);
      });
    });
  }

  function getCurrentHandle() {
    var el = document.querySelector('[data-product-handle]');
    if (el) return el.getAttribute('data-product-handle');

    var match = window.location.pathname.match(/\/products\/([^/?#]+)/);
    return match ? match[1] : null;
  }

  document.addEventListener('DOMContentLoaded', function () {
    var handle = getCurrentHandle();
    if (handle) {
      trackProduct(handle);
    }
    if (document.getElementById('recently-viewed-grid')) {
      renderSection('recently-viewed-grid', handle);
    }
  });

  return {
    getHandles: getHandles,
    trackProduct: trackProduct,
    renderSection: renderSection,
  };
})();
